// ANNO 2020
//
// export const GROUPS_ELEM = [
//   "Brembo",
//   "Chiesa",
//   "Cave",
//   "Arena",
//   "Centro Sportivo",
//   "Piazzale del Mercato",
//   "Villa Tasca",
//   "Castello Moretti",
//   "Villaggio dei Puffi",
//   "Salici",
//   "Put Castel",
//   "Le Betulle",
//   "Parco Donati",
//   "Parco Ricci",
// ]

// export const GROUPS_MEDIE = [
//   "Casa Parrocchiale",
//   "Piazza",
//   "Ponte Vecchio",
//   "Villa Morlacchi",
//   "San Vittore",
//   "Piazzale Lamarmora",
//   "Filarola",
// ]
//
// FINE ANNO 2020

// ANNO 2021
// export const GROUPS_ELEM = [
//   // 1a elem
//   "Sparviero",
//   "Lupo ghiaccio",
//   // 2a elem
//   "Nascondino",
//   "Bandierina",
//   // 3a elem
//   "Mario Bros",
//   "Crash Bandicoot",
//   // 4a elem
//   "Tetris",
//   "Snake",
//   // 5a elem
//   "Flipper",
//   "PacMan"
// ]

// export const GROUPS_MEDIE = [
//   // 1a media
//   "Scarabeo",
//   "Taboo",
//   // 2a media
//   "Monopoli",
//   "Dixit",
//   // 3a media
//   "Risiko",
// ]
// FINE ANNO 2021

// ANNO 2022
export const GROUPS_ELEM = [
  // 1a elem
  "1a elem A",
  "1a elem B",
  // 2a elem
  "2a elem A",
  "2a elem B",
  // 3a elem
  "3a elem A",
  "3a elem B",
  // 4a elem
  "4a elem A",
  "4a elem B",
  // 5a elem
  "5a elem A",
  "5a elem B"
]

export const GROUPS_MEDIE = [
  // 1a media
  "1a media A",
  "1a media B",
  // 2a media
  "2a media A",
  "2a media B",
  // 3a media
  "3a media A",
  "3a media B",
]
// FINE ANNO 2022

export const GROUPS = [].concat(GROUPS_ELEM, GROUPS_MEDIE)

export const PLACES = [
  { location: "Oratorio Esterno", name: "Calcio", incompatible: [], capacity: 2 },
  { location: "Oratorio Esterno", name: "Basket", incompatible: [], capacity: 2 },
  { location: "Oratorio Esterno", name: "Pallavolo", incompatible: [], capacity: 2 },
  { location: "Oratorio Esterno", name: "Arena Nuova", incompatible: [], capacity: 2 },
  { location: "Oratorio Esterno", name: "Viale Ingresso", incompatible: [], capacity: 2 },
  { location: "Oratorio Esterno", name: "Portico sala giochi", incompatible: [], capacity: 1 },
  { location: "Oratorio Esterno", name: "Portico bar", incompatible: [], capacity: 1 },
  { location: "Oratorio Esterno", name: "Arena", incompatible: [], capacity: 3 },
  { location: "Oratorio Interno", name: "Salone", incompatible: [], capacity: 2 },
  { location: "Oratorio Interno", name: "Cucina", incompatible: [], capacity: 2 },
  { location: "Oratorio Interno", name: "Sala giochi", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula 1", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula 2", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula 3", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula 6", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula 7", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula 8", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula 10", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula 11", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula 12", incompatible: [], capacity: 1 },
  { location: "Oratorio Interno", name: "Aula Rossa", incompatible: [], capacity: 1 },
  { location: "Elementari", name: "Elem01", incompatible: [], capacity: 1 },
  { location: "Elementari", name: "Elem02", incompatible: [], capacity: 1 },
  { location: "Elementari", name: "Elem03", incompatible: [], capacity: 1 },
  { location: "Elementari", name: "Elem11", incompatible: [], capacity: 1 },
  { location: "Elementari", name: "Elem12", incompatible: [], capacity: 1 },
  { location: "Elementari", name: "Elem13", incompatible: [], capacity: 1 },
  { location: "Elementari", name: "Elem0", incompatible: [], capacity: 1 },
  { location: "Elementari", name: "Elem1", incompatible: [], capacity: 1 },
  { location: "Elementari", name: "Giardino", incompatible: [], capacity: 5 },
  { location: "Villa Tasca", name: "Ricci Sopra", incompatible: [], capacity: 3 },
  { location: "Villa Tasca", name: "Ricci Sotto", incompatible: [], capacity: 2 },
  { location: "Villa Tasca", name: "Arena Civica", incompatible: [], capacity: 4 },
  { location: "Centro Sportivo", name: "Sportivo", incompatible: [], capacity: 5 },
  { location: "Centro Sportivo", name: "Calcetto", incompatible: [], capacity: 2 },
  { location: "Parchi", name: "Mayr", incompatible: [], capacity: 2 },
  { location: "Parchi", name: "Lamarmora", incompatible: [], capacity: 2 },
  { location: "Parchi", name: "Corda", incompatible: [], capacity: 1 },
  { location: "Parchi", name: "Nullo", incompatible: [], capacity: 1 },
  { location: "Parchi", name: "Moroni", incompatible: [], capacity: 1 },
  { location: "Parchi", name: "Repubblica", incompatible: [], capacity: 1 },
  { location: "Parchi", name: "Chiosi", incompatible: [], capacity: 2 },
  { location: "Parchi", name: "Arnichi", incompatible: [], capacity: 3 },
  { location: "Oriens", name: "Oriens", incompatible: [], capacity: 5 },
  { location: "Altro", name: "In giro", incompatible: [], capacity: 30 },
  { location: "Altro", name: "Crespi", incompatible: [], capacity: 30 },
  { location: "Altro", name: "SanVittore", incompatible: [], capacity: 1 },
  { location: "Altro", name: "Biblioteca", incompatible: [], capacity: 1 },
  { location: "Altro", name: "Palestra Oriens", incompatible: [], capacity: 2 },

]